export const profile = {
  name: 'Seungho Choi',
  handle: 'PLANETARY',
  role: 'Systems Engineer',
  base: 'Busan, Republic of Korea',
  email: 'admin@itsmyhub.me',
  phone: '+82 10 8486 5476',
};

export const links = {
  notion: 'https://itismy.notion.site/On-the-Grind-79bc344b00784246aab102297e6944d5?pvs=4',
  linkedin: 'https://www.linkedin.com/in/itsmyplanetary',
  github: 'https://github.com/itsmyCareer',
  blog: 'https://blog.itsmyplanetary.me',
};

export const company = {
  en: {
    name: 'Planetary',
    ceo: 'Seungho Choi',
    address: '308, 17 Gampo-ro 88beon-gil, Suyeong-gu, Busan, Republic of Korea',
    biz: '221-23-53160',
  },
  ko: {
    name: '플래니터리(Planetary)',
    ceo: '최승호',
    address: '부산광역시 수영구 감포로88번길 17, 308호',
    biz: '221-23-53160',
  },
  ja: {
    name: 'Planetary',
    ceo: '崔承鎬',
    address: '大韓民国 釜山広域市 水営区 甘浦路88番ギル 17, 308号',
    biz: '221-23-53160',
  },
  zh: {
    name: 'Planetary',
    ceo: '崔承搞',
    address: '大韩民国 釜山广域市 水营区 甘浦路88番路 17号 308室',
    biz: '221-23-53160',
  },
};
